// src/app/public-home/PublicHome.tsx

import * as React from "react";

import {
  PublicFooter,
} from "../../components/PublicFooter";

import {
  Seo,
} from "../../components/Seo";

import {
  AccessRequestForm,
} from "./AccessRequestForm";

import {
  PublicHero,
} from "./PublicHero";

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export default function PublicHome():
React.JSX.Element {
  return (
    <main className="public-site">
      <Seo
        title="Estatly | Property work in one place"
        description="The property, the work and the people in one place."
        canonicalPath="/"
      />

      <PublicHero />

      <section
        className="public-roles"
        aria-label="Who Estatly is for"
      >
        <div className="public-container public-role-grid">
          <article className="public-role">
            <p className="public-role-label">
              Property managers
            </p>

            <p>
              Keep the property, maintenance work and everyone involved connected from instruction to completion.
            </p>
          </article>

          <article className="public-role">
            <p className="public-role-label">
              Self-managed owners
            </p>

            <p>
              Manage property work without piecing together messages, files and contractors across different places.
            </p>
          </article>

          <article className="public-role">
            <p className="public-role-label">
              Tradespeople
            </p>

            <p>
              See the property, the authorised work and the people you need to coordinate with in one place.
            </p>
          </article>
        </div>
      </section>

      <section
        id="request-access"
        className="public-access"
      >
        <div className="public-container public-access-grid">
          <div className="public-access-heading">
            <p className="public-section-label">
              Request access
            </p>

            <h2>
              Tell us who you are.
            </h2>

            <p>
              We’ll get in touch about access to Estatly.
            </p>
          </div>

          <div className="public-access-form-wrap">
            <AccessRequestForm />
          </div>
        </div>
      </section>

      <PublicFooter />
    </main>
  );
}